import React, { useEffect, useState, useMemo } from "react";
import * as Global from "../../../styles/Global";
import { setModal } from "../../../features/modals/modalSlice";
import SlideUp from "../../../components/modals/SlideUp";
import { connect, useSelector } from "react-redux";

const mapDispatch = {
  setModal,
};

const MainProfileModals = ({ isDifferentUser }) => {
  const playerModals = useSelector((state) => state.modal.playerModals);
  const playerModals2 = useSelector((state) => state.modal.playerModals2);
  const globalModals = useSelector((state) => state.modal.globalModals);
  const globalModals2 = useSelector((state) => state.modal.globalModals2);

  console.log("playerModals: ", playerModals);
  console.log("playerModals2: ", playerModals2);
  console.log("globalModals: ", globalModals);
  console.log("globalModals2: ", globalModals2);

  return (
    !isDifferentUser && (
      <>
        <SlideUp
          displayModal={playerModals.showModal}
          setDisplayModal={() =>
            setModal({
              playerModals: { showModal: false, modalType: 25, data: {} },
            })
          }
          modalType={playerModals.modalType}
          CloseModalAction={() =>
            setModal({
              playerModals: { showModal: false, modalType: 25, data: {} },
            })
          }
          overlayZIndex={501}
          data={playerModals.data}
          // displayFlex
          background={
            [28].includes(playerModals.modalType)
              ? Global.contentBackgroundColor
              : [26, 28, 29].includes(playerModals.modalType)
              ? "#fff"
              : "linear-gradient(-203deg, #E08185 0,#9F93CF 74%, #8989D5 100%)"
          }
        />
        <SlideUp
          displayModal={playerModals2.showModal}
          setDisplayModal={() =>
            setModal({
              playerModals2: { showModal: false, modalType: 25, data: {} },
            })
          }
          modalType={playerModals2.modalType}
          CloseModalAction={() =>
            setModal({
              playerModals2: { showModal: false, modalType: 25, data: {} },
            })
          }
          overlayZIndex={502}
          data={playerModals2.data}
          // displayFlex
          background={
            [28].includes(playerModals2.modalType)
              ? Global.contentBackgroundColor
              : [26, 28, 29].includes(playerModals2.modalType)
              ? "#fff"
              : "linear-gradient(-203deg, #E08185 0,#9F93CF 74%, #8989D5 100%)"
          }
        />
        <SlideUp
          displayModal={globalModals.showModal}
          setDisplayModal={() =>
            setModal({
              globalModals: { showModal: false, modalType: 29, data: {} },
            })
          }
          modalType={globalModals.modalType}
          CloseModalAction={() =>
            setModal({
              globalModals: { showModal: false, modalType: 29, data: {} },
            })
          }
          overlayZIndex={602}
          data={globalModals.data}
          // displayFlex
        />
        <SlideUp
          displayModal={globalModals2.showModal}
          setDisplayModal={() =>
            setModal({
              globalModals2: { showModal: false, modalType: 29, data: {} },
            })
          }
          modalType={globalModals2.modalType}
          CloseModalAction={() =>
            setModal({
              globalModals2: { showModal: false, modalType: 29, data: {} },
            })
          }
          overlayZIndex={603}
          data={globalModals2.data}
          // displayFlex
        />
      </>
    )
  );
};

export default connect(null, mapDispatch)(MainProfileModals);
